import { Game } from '../responses/game';
import { CacheEntry } from './cache-entry';
import { CacheKey } from './cache-key.enum';
import { CacheStorageType } from './cache-storage-type.enum';

/** Jogos mudam raramente: TTL próprio, maior que o padrão de 60s do cache genérico. */
const GAMES_CACHE_TTL_SECONDS = 5 * 60;

export class GamesCache extends CacheEntry<Game[]> {
  constructor(games?: Game[], ttlSeconds: number = GAMES_CACHE_TTL_SECONDS) {
    super(CacheKey.Games, CacheStorageType.Local, ttlSeconds, games);
  }

  override create(): void {
    super.create();
  }

  override get(): Game[] {
    return super.get();
  }
}
